export default class ArticleController {
    constructor() {
        this.scrollToContentSelector = '.scroll-to-content';
        this.initScrollToContent();
    }

    initScrollToContent() {
        const elements = document.querySelectorAll(this.scrollToContentSelector);
        for (let i = 0; i < elements.length; i++) {
            const targetSelector = elements[i].dataset.target;
            elements[i].addEventListener('click', () => {
                const navOffset = document.querySelector('header.nav-header').offsetHeight;
                const targetElementPosition = document.querySelector(targetSelector).getBoundingClientRect().top;
                const offsetPosition = targetElementPosition - navOffset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth',
                });
            });
        }
    }

    static init() {
        document.addEventListener('DOMContentLoaded', () => {
            new ArticleController(); // eslint-disable-line no-new
        });
    }
}


